module.exports = __webpack_public_path__ + "static/media/search_icon.9000049f.svg";